<template>
    <div class="class-1" id="dinein">
            <PosAppHeader />

    
  <div class="bills-container">
    <!-- Header -->
    <!-- Filter Options -->
    <div class="filter-options">
      <div class="date-filter">
        <label for="startDate">From:</label>
        <input type="date" id="startDate" v-model="startDate" @change="fetchPayments">
        
        <label for="endDate">To:</label>
        <input type="date" id="endDate" v-model="endDate" @change="fetchPayments">
      </div>
      
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchQuery" 
          placeholder="Search by order ID..." 
          @input="filterPayments"
        >
      </div>
    </div>

    <!-- Bills Table -->
    <div class="table-responsive">
      <table id="billsTable">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Payment ID</th>
            <th>Amount (AED)</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="filteredPayments.length > 0">
            <tr v-for="(order, index) in filteredPayments" :key="index">
              <td>{{ order.order_id }}</td>
              <td>
                <div v-if="order.payments.length > 0">
                  <div v-for="(payment, pIndex) in order.payments" :key="pIndex">
                    {{ payment.payment_id }}
                  </div>
                </div>
                <div v-else>No payments</div>
              </td>
              <td>
                <div v-if="order.payments.length > 0">
                  <div v-for="(payment, pIndex) in order.payments" :key="pIndex">
                    {{ payment.amount }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td>
                <div v-if="order.payments.length > 0">
                  <div v-for="(payment, pIndex) in order.payments" :key="pIndex">
                    {{ formatDate(payment.created_at) }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="4" class="no-data">No payments found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    const today = new Date();
    const todayFormatted = today.toISOString().split('T')[0];
    return {
      orders: [],
      filteredPayments: [],
      searchQuery: '',
      startDate: todayFormatted,
      endDate: todayFormatted,
      currentDate: '',
      currentTime: '',
    };
  },
  mounted() {
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.fetchPayments();
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
      async fetchPayments() {
    try {
      this.$root.isLoading = true;
      const token = localStorage.getItem('authToken');
      
      // Fetch ALL payments without date filtering first
      const response = await fetch(
        `${this.$BASE_API_URL}/api/orders/payments`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error('Network response was not ok');
      
      const data = await response.json();
      this.orders = data.data;
      this.applyFilters(); // Apply filters after loading all data
    } catch (error) {
      console.error('Error fetching payments:', error);
      this.$toast.error('Failed to fetch payments');
    } finally {
      this.$root.isLoading = false;
    }
  },
  
  applyFilters() {
    let filtered = this.orders.filter(order => order.payments.length > 0);
    
    // Apply date filter if dates are selected
    if (this.startDate || this.endDate) {
      const start = this.startDate ? new Date(this.startDate) : null;
      const end = this.endDate ? new Date(this.endDate + 'T23:59:59') : null; // Include entire end day
      
      filtered = filtered.filter(order => {
        return order.payments.some(payment => {
          const paymentDate = new Date(payment.created_at);
          return (!start || paymentDate >= start) && (!end || paymentDate <= end);
        });
      });
    }
    
    // Apply search filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(order => 
        order.order_id.toString().includes(query)
      );
    }
    
    this.filteredPayments = filtered;
  },
  
  // Update these methods to use applyFilters instead
  filterPayments() {
    this.applyFilters();
  },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }
  }
};
</script>

<style scoped>
.bills-container {
  padding: 20px;
}

.filter-options {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-box input {
  padding: 8px 15px;
  border: 1px solid;
  border-radius: 4px;
  min-width: 250px;
}

.table-responsive {
  overflow-x: auto;
}

#billsTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

#billsTable th, #billsTable td {
  border: 1px solid;
  padding: 12px;
  text-align: left;
}

#billsTable th {
  font-weight: bold;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #666;
}

@media (max-width: 768px) {
  .filter-options {
    flex-direction: column;
  }
  
  .date-filter {
    flex-wrap: wrap;
  }
}
</style>